import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";
import * as actionTypes from "MODULES/shared/actionTypes";

const actionFactory = (t, r) => `${t}_${r}`;

export function getAttachments(id, resourceType) {
  return dispatch => {
    dispatch({
      type: [actionFactory(actionTypes.GET_ATTACHMENTS, resourceType)]
    });

    return api.attachments.list(id, resourceType).then(resp =>
      dispatch({
        type: [actionFactory(actionTypes.SET_ATTACHMENTS, resourceType)],
        attachments: resp.data.results
      })
    );
  };
}

export function upload(
  id,
  resourceType,
  { file, attachment_type, description, reference_number }
) {
  const fileName = `${+new Date() -
    Math.floor(Math.random() * 10000000000)}${file.name}`;
  return dispatch =>
    api.attachments.upload(fileName).then(resp => {
      const { key, url } = resp.data;
      const attachment = {
        description,
        name: fileName,
        key,
        attachment_type,
        reference_number
      };

      return api.attachments.toS3(url, file).then(() =>
        api.attachments
          .create(id, resourceType, attachment)
          .then(createResp => {
            dispatch({
              type: [actionFactory(actionTypes.ADD_ATTACHMENT, resourceType)],
              attachment: createResp.data
            });
            return SUCCESS;
          })
      );
    });
}

const sanitizeFileName = name =>
  name.replace(/[^0-9a-zA-Z! _\\.\\*'\\(\\)\\-]/g, "");

export function multiUpload(id, resourceType, fileData) {
  const promises = fileData.file.map(f => {
    const fileName = `${+new Date() -
      Math.floor(Math.random() * 10000000000)}${sanitizeFileName(f.name)}`;
    return api.attachments.upload(fileName).then(({ data }) => ({
      description: fileData.description,
      file: f,
      name: fileName,
      key: data.key,
      url: data.url,
      attachment_type: fileData.attachment_type,
      reference_number: fileData.reference_number
    }));
  });

  const files = Promise.all(promises);

  return dispatch =>
    files.then(values =>
      values.forEach(
        ({
          name,
          key,
          attachment_type,
          description,
          file,
          url,
          reference_number
        }) =>
          api.attachments.toS3(url, file).then(() => {
            const attachment = {
              name,
              key,
              attachment_type,
              reference_number,
              description
            };
            return api.attachments
              .create(id, resourceType, attachment)
              .then(createResp => {
                dispatch({
                  type: [
                    actionFactory(actionTypes.ADD_ATTACHMENT, resourceType)
                  ],
                  attachment: createResp.data
                });
                return SUCCESS;
              });
          })
      )
    );
}

export function update(id, resourceType, data) {
  return dispatch =>
    api.attachments.update(id, data).then(resp => {
      dispatch({
        type: [actionFactory(actionTypes.UPDATE_ATTACHMENT, resourceType)],
        attachment: resp.data
      });
      return SUCCESS;
    });
}

export function link(id, resourceType, attachment) {
  const data = {
    ...attachment,
    name: attachment.link_url,
    attachment_type: "external_link"
  };

  return dispatch =>
    api.attachments.create(id, resourceType, data).then(resp => {
      dispatch({
        type: [actionFactory(actionTypes.ADD_ATTACHMENT, resourceType)],
        attachment: resp.data
      });
      return SUCCESS;
    });
}

export function destroyAttachment(id, resourceType) {
  return dispatch =>
    api.attachments.destroy(id).then(() => {
      dispatch({
        type: [actionFactory(actionTypes.REMOVE_ATTACHMENT, resourceType)],
        id
      });
    });
}



// WEBPACK FOOTER //
// ./app/modules/shared/actions/attachments.js